import React from "react"
import { TextAnalyticsPlusDexie } from "../db"

export const DatabaseContext = React.createContext<{
    database: TextAnalyticsPlusDexie | undefined
}>({
    database: undefined,
})
